// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  background-color: #010826 !important;
  color: #b6b6b6 !important;
}
nav * {
  color: inherit !important;
}`, "",{"version":3,"sources":["webpack://./src/components/header/index.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;EACA,yBAAA;AACJ;AAAI;EACI,yBAAA;AAER","sourcesContent":["nav {\n    background-color: #010826 !important;\n    color: #b6b6b6 !important;\n    * {\n        color: inherit !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
